import { useEffect, useRef, useState } from 'react';

// Delays showing the spinner so fast loads don't flash it, and keeps it up long enough not to blink once shown.
export const useDelayedSpinner = (loading: boolean, delay = 200, minDuration = 400): boolean => {
  const [visible, setVisible] = useState(false);
  const shownAtRef = useRef(0);

  useEffect(() => {
    if (loading) {
      if (visible) return undefined;

      const timer = window.setTimeout(() => {
        shownAtRef.current = Date.now();
        setVisible(true);
      }, delay);
      return () => window.clearTimeout(timer);
    }

    if (!visible) return undefined;

    const remaining = Math.max(0, minDuration - (Date.now() - shownAtRef.current));
    const timer = window.setTimeout(() => setVisible(false), remaining);
    return () => window.clearTimeout(timer);
  }, [loading, visible, delay, minDuration]);

  return visible;
};

export default useDelayedSpinner;
